export const historyData = [
    {
        id: '1',
        year: '2011',
        title: 'Основание агентства',
        subtitle: 'Старт ежегодных конференций по интернет-маркетингу «ТРИМ»',
        text: 'Сертификация Яндекс',
        content:
            'Приход ключевых сотрудников: Анастасия Андронова, CMO маркетинг, Иван Поддубный, CTO',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '2',
        year: '2012',
        title: 'Операционное развитие агентства',
        subtitle: 'Рост клиентской базы',
        text: 'Разработка первого корпоративного сайта на платформе Bitrix',
        content: '',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '3',
        year: '2013',
        title: 'Выделение в структуре фронт- и бэк-офиса, отделов SEO, рекламы, менеджеров проектов',
        subtitle: 'Партнерство с компанией «Ровен»',
        text: '',
        content: '',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '4',
        year: '2014',
        title: 'Основание Южной школы интернет-бизнеса',
        subtitle: 'Сертификация Google IQ',
        text: '50+ региональных корпоративных клиентов',
        content: '',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '5',
        year: '2015',
        title: 'Нас 25 человек',
        subtitle: 'Сертификация Google Partners',
        text: 'Первый федеральный клиент — «Российская венчурная компания»',
        content: '',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '6',
        year: '2016',
        title: 'Золотой сертифицированный партнер «1C-Битрикс»',
        subtitle: '1 место в «Рейтинге Рунета» среди SEO-компаний ЮФО',
        text: 'Старт работы с таргетированной рекламой в соцсетях и ведения сообществ',
        content: 'Партнерство с брендами «Темпавто», VIRBACauto, «Додо-пицца»',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '7',
        year: '2017',
        title: 'Начало работы со сквозной аналитикой и персонализированным маркетингом',
        subtitle: 'Создание выделенного внутреннего DevOps-отдела на смену аутсорсу',
        text: 'Первые проекты на react',
        content: 'Партнерство с «ЛУКОЙЛ», «КПИ», BONUM',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '8',
        year: '2018',
        title: 'Юниты «Разработка» и «Маркетинг» формируются как самостоятельные структуры',
        subtitle: 'Запуск собственного сервиса — конвертор файлов onlineconvertfree.com',
        text: 'Партнерство с «Российским экспортным центром», «Мособлгаз»',
        content: "Международный проект для «Л'этуаль»",
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '9',
        year: '2019',
        title: 'Нас 60 человек',
        subtitle: 'Формирование команд для работы с крупными проектами',
        text: 'Получение уверенной экспертизы по Kubernetes',
        content:
            // eslint-disable-next-line max-len
            'Разработка сложных сервисов для госструктур и В2В-клиентов: Фонд ЖКХ, «Корпорация развития Дальнего Востока и Арктики», «Сколково», «Роснано», «Роскосмос», «Ростелеком», «МТС-Инвестиции», Яндекс.Касса',
        subcontent: 'Развитие международного проекта Bloomex',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '10',
        year: '2020',
        title: 'Внедрена собственная система грейдов с понятной карьерной лестницей',
        subtitle: 'Разработка высоконагруженных систем для «Почта-Банк», конкурса «ПРО/ЧТЕНИЕ»',
        // eslint-disable-next-line max-len
        text: 'Награды Red Dot, «Золотой сайт», «Событие года», «Серебряный Лучник» за разработку платформы для международного киберфестиваля Rukami',
        content: 'Сформирован отдел контента',
        subcontent: '',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '11',
        year: '2021',
        title: '> 80% проектов на react ',
        subtitle:
            '1 место в «Рейтинге Рунета» среди агентств России по разработке и продвижению сайтов в премиум-сегменте',
        text: 'Запуск собственного проекта Linkbuilder.ai',
        content:
            'Партнерства с Агентством стратегических инициатив по нескольким ключевым проектам',
        subcontent: 'Интегратор ИT-решений для крупного бизнеса Bitrix Enterprise',
        subtext: '',
        description: '',
        subdescription: '',
    },
    {
        id: '12',
        year: '2022',
        title: '100+ человек в команде',
        subtitle:
            '1 место в «Рейтинге Рунета» среди агентств России интернет-маркетинга / Верхний ценовой сегмент',
        text: '6 место в «Рейтинге Рунета» по созданию и продвижению сайтов',
        content: '35 место в «Национальном рейтинге коммуникационных компаний»',
        subcontent: '39 место среди агентств полного цикла в России (Ruward)',
        subtext:
            'В клиентском портфеле более 150 крупных региональных производителей B2B-сегмента, федеральных брендов',
        description: 'Создали новое комьюнити rndSEO',
        subdescription: 'Сооснователь фонда «Развитие ИТ-образования»',
    },
    {
        id: '13',
        year: '2023',
        title: '1 место среди премиум-агентств интернет-маркетинга в «Рейтинге Рунета»',
        subtitle: '1 место в «Рейтинге Рунета» по ведению аккаунта в соцсетях',
        text: '2 место  по созданию и продвижению сайтов для корпораций в «Рейтинге Рунета»',
        content:
            // eslint-disable-next-line max-len
            'Разработка сложных сервисов и развитие веб-проектов для «Газпромнефть», «Росгосстрах», Российского экспортного центра, Фонда развития территорий',
        subcontent:
            'Победа в Workspace Digital Awards-2023 в категории лучшие сайты для финансовой сферы',
        subtext:
            'Новые партнеры по SEO: «Промсвязьбанк», «Ренессанс Банк», «Открытие, «ОТП Банк», «Центр-инвест»',
        description: '30 место в «Национальном рейтинге коммуникационных компаний»',
        subdescription:
            'Собственный продукт агентства облачный конвертер файлов включен в реестр российского ПО',
    },
    {
        id: '14',
        year: '2024',
        title: 'Реализовали 15 крупных проектов для финтеха, промышленности, недвижимости и госкорпораций',
        subtitle: 'Вывели на рынок новый собственный продукт SkillsTeam',
        text: 'Получили статус сертифицированного партнера-интегратора Yandex Cloud и лицензию ФСТЭК',
        content:
            'Взяли серебро Workspace Digital Awards 2024, 3 место RUWARD AWARD 2024 и получили 5 наград Tagline ' +
            'Awards 2024',
        subcontent:
            '2 место среди комплексных диджитал-агентств России в Рейтинге Рунета 2024, 4 место среди ' +
            'диджитал-подрядчиков для госстурктур и 5 место в рейтинге «Разработка и продвижение сайтов»',
        subtext:
            'Сделали ребрендинг, обновили миссию и ценности, запустили собственную корпоративную валюту и ' +
            'магазин мерча',
        description:
            'Стартовала «Школа лидеров» для развития управленческих компетенций руководителей',
        subdescription: '',
    },
    {
        id: '15',
        year: '2025',
        title: 'Стали резидентами «Сколково»',
        subtitle:
            'Получили лицензию ФСБ, подтвердив высший уровень защиты данных для\u00A0корпоративных ' +
            'и\u00A0государственных проектов',
        text: '1\u00A0место среди лучших работодателей Ростовской области по\u00A0версии HeadHunter',
        content: 'Запустили ИИ-интегратора Вебпрактик AI',
        subcontent: 'Вывели на\u00A0рынок продукты AgentFlow\u00A0AI и\u00A0Talent\u00A0Mind',
        subtext: 'Запустили обновленную платформу Добро.рф\u00A03.0',
        description:
            'Победили на\u00A0Workspace Digital Awards\u00A02025 и\u00A0Tagline Awards\u00A02025',
        subdescription: 'Расширили поддержку ИТ-сообществ',
    },
];
